// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10 17.0845C13.912 17.0845 17.0833 13.9132 17.0833 10.0011C17.0833 7.64652 15.9344 5.56025 14.1667 4.2723M10.8333 18.6678L9.16666 17.0011L10.8333 15.3345M10 2.91781C6.08798 2.91781 2.91666 6.08912 2.91666 10.0011C2.91666 12.3558 4.06555 14.442 5.83333 15.73M9.16666 4.66781L10.8333 3.00114L9.16666 1.33447"
    />
  </svg>
);
const IconRepeat = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconRepeat;
